<template>
  <vue-delayed-multiselect-ajax
      :key="`${_uid}-tickets`"
      :custom-label="customLabel"
      :disabled="disabled"
      :name="name || 'farm_id'"
      :params="{ ...params }"
      :placeholder="$t('Select {something}', { something: $t('tickets.singular') })"
      :required="required"
      :url="`/tickets`"
      :value="value"
      v-on="$listeners"
  >
    <template v-slot:beforeList>
      <b-button v-b-modal="`${_uid}-ticket-create-modal`" variant="link">+
        {{ $t('Add new {something}', {something: $t('tickets.singular')}) }}
      </b-button>
      <ticket-create-modal
          :id="`${_uid}-ticket-create-modal`"
          :key="`${_uid}-ticket-create-modal-${value}`"
          size="lg"
          @created="onInput($event.id)"
      ></ticket-create-modal>
    </template>
    <template v-slot:option="{ option }">
      <slot name="option" v-bind="{ option }"></slot>
    </template>
  </vue-delayed-multiselect-ajax>
</template>

<script>
import TicketCreateModal from '../modals/ticket-create';
import VueDelayedMultiselectAjax from "@/components/inputs/vue-delayed-multiselect-ajax.vue";

export default {
  name: 'ticket-select-ajax',
  components: {
    VueDelayedMultiselectAjax,
    TicketCreateModal,
  },
  props: {
    name: {
      type: String,
      default: undefined
    },
    value: {
      type: Number,
      default: undefined
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      default: function () {
        return {
          with: 'creator',
        }
      }
    },
    initialValue: {
      type: Object,
      default() {
        return {};
      }
    },
    customLabel: {
      type: Function,
      default({
                id,
                customer_type,
                created_at,
                creator: {
                  name: creator_name
                } = {}
              }) {
        return `${id}: ${this.$t(`tickets.customer_types.${customer_type}`)}, ${this.$t('created_by_{name}_on_{date}', {
          name: creator_name,
          date: this.$moment.utc(created_at).local().format('DD MMMM YYYY')
        })}`
      }
    },
    loaded: {
      type: Function,
      default() {
        return () => {
        };
      }
    }
  },
  methods: {
    onInput(event) {
      this.$emit('input', event)
    },
    clearAll() {
      this.$emit('input', undefined)
    },
    x() {
      // window.console.log('loaded')
    }
  }
}
</script>

<style scoped>

</style>